import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DownloadFileGlyph = /*#__PURE__*/createElement("g", {
  id: "download_file",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M51.5 69.5C61.4411 69.5 69.5 61.4411 69.5 51.5C69.5 41.5589 61.4411 33.5 51.5 33.5C41.5589 33.5 33.5 41.5589 33.5 51.5C33.5 61.4411 41.5589 69.5 51.5 69.5Z",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M51.5 42.5V60.5",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M51.5 60.5L44.75 53.75",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M51.5 60.5L58.25 53.75",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M22.25 60.5H6.5C5.30653 60.5 4.16193 60.0259 3.31802 59.182C2.47411 58.3381 2 57.1935 2 56V6.5C2 5.30653 2.47411 4.16193 3.31802 3.31802C4.16193 2.47411 5.30653 2 6.5 2H38.387C39.5801 2.00105 40.7239 2.47585 41.567 3.32L50.183 11.933C50.6008 12.3511 50.9322 12.8473 51.1581 13.3935C51.3841 13.9396 51.5003 14.525 51.5 15.116V22.25",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const DownloadFile = createSvg({
  name: 'download_file',
  path: DownloadFileGlyph
});

export default DownloadFile;
export { DownloadFileGlyph };
